module.exports = __webpack_public_path__ + "static/media/et.6f764338.jpg";